import { createContext } from 'react';

interface OriginalLocationContextState {
  originalUrl: string | null;
}
export const OriginalLocationContext = createContext<OriginalLocationContextState>({ originalUrl: null });
